/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update an existing task template
 * @export
 * @interface UpdateTaskTemplateRequest
 */
export interface UpdateTaskTemplateRequest {
    /**
     * Title of the task
     * @type {string}
     * @memberof UpdateTaskTemplateRequest
     */
    title?: string;
    /**
     * Optional description of the task
     * @type {string}
     * @memberof UpdateTaskTemplateRequest
     */
    description?: string | null;
    /**
     * Task priority level
     * @type {string}
     * @memberof UpdateTaskTemplateRequest
     */
    priority?: UpdateTaskTemplateRequestPriorityEnum;
    /**
     * Number of days after status change when task is due
     * @type {number}
     * @memberof UpdateTaskTemplateRequest
     */
    dueDaysOffset?: number | null;
    /**
     * Role that should be assigned this task
     * @type {string}
     * @memberof UpdateTaskTemplateRequest
     */
    assigneeRole?: string | null;
    /**
     * Order in which tasks should be displayed
     * @type {number}
     * @memberof UpdateTaskTemplateRequest
     */
    displayOrder?: number;
    /**
     * Whether this task is required to complete the status
     * @type {boolean}
     * @memberof UpdateTaskTemplateRequest
     */
    isRequired?: boolean;
}


/**
 * @export
 */
export const UpdateTaskTemplateRequestPriorityEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high',
    Urgent: 'urgent'
} as const;
export type UpdateTaskTemplateRequestPriorityEnum = typeof UpdateTaskTemplateRequestPriorityEnum[keyof typeof UpdateTaskTemplateRequestPriorityEnum];


/**
 * Check if a given object implements the UpdateTaskTemplateRequest interface.
 */
export function instanceOfUpdateTaskTemplateRequest(value: object): value is UpdateTaskTemplateRequest {
    return true;
}

export function UpdateTaskTemplateRequestFromJSON(json: any): UpdateTaskTemplateRequest {
    return UpdateTaskTemplateRequestFromJSONTyped(json, false);
}

export function UpdateTaskTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTaskTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'dueDaysOffset': json['dueDaysOffset'] == null ? undefined : json['dueDaysOffset'],
        'assigneeRole': json['assigneeRole'] == null ? undefined : json['assigneeRole'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
    };
}

export function UpdateTaskTemplateRequestToJSON(json: any): UpdateTaskTemplateRequest {
    return UpdateTaskTemplateRequestToJSONTyped(json, false);
}

export function UpdateTaskTemplateRequestToJSONTyped(value?: UpdateTaskTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'priority': value['priority'],
        'dueDaysOffset': value['dueDaysOffset'],
        'assigneeRole': value['assigneeRole'],
        'displayOrder': value['displayOrder'],
        'isRequired': value['isRequired'],
    };
}

